import { Button, Dialog, DialogActions, DialogContent, DialogTitle, FormControl, Input, InputLabel, Paper, Stack, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import React, { useRef, useState } from "react";
import { useEffect } from "react";
import companyService from "../../services/companyService";
import darkWebService from "../../services/darkWebService";
import riskService from "../../services/riskService";
import SubmitModal from "../Admin/SubmitModal";

const SyntheticIDModal = (props) => {

	let [ syntheticIds, setSyntheticIds ] = useState(riskService.syntheticIds);
	let [ showSubmitModal, setShowSubmitModal ] = useState(false);
	let [ sentSuccess, setSentSuccess ] = useState(false);
	
	const system = useRef(null);
	const reference = useRef(null);
	
	useEffect(() => {
		setSyntheticIds(riskService.syntheticIds);
	}, []);
	
	const handleSubmit = async () => {
		setSentSuccess(false);
		setShowSubmitModal(true);
		
		await riskService.addSyntheticId(system.current.value, reference.current.value);
		await darkWebService.all(companyService.selectedCompany.id);
		setSyntheticIds(riskService.syntheticIds);
		
		setSentSuccess(true);
		setTimeout(() => {
			setShowSubmitModal(false);
			clearForm();
		}, 1500);
	};

	const handleSubmitForm = () => {
		handleSubmit();
	};
	
	const handleCancel = () => {
		props.onClose();
	};
	
	const handleClose = () => {
		props.onClose();
	};
	
	const handleSubmitModalClose = () => {
		setSentSuccess(false);
		setShowSubmitModal(false);
		clearForm();
	};
	
	const clearForm = () => {
		system.current.value = "";
		reference.current.value = "";
	};
	
	const formControlStyle = {
		width: "80%",
		margin: "1em 10%"
	};
	
	return (
		<Dialog
			open={props.open}
			onClose={handleClose}
			aria-labelledby="alert-dialog-title"
			aria-describedby="alert-dialog-description"
			fullWidth={true}
			maxWidth="lg"
			sx={{ margin: "auto", overflow: "auto" }}
		>
			<DialogTitle id="alert-dialog-title">
				{`Synthetic ID's`}
			</DialogTitle>
			<DialogContent sx={{ height: "100%", overflow: "auto" }}>
				<Stack direction="column" sx={{ overflow: "hidden", height: "100%", padding: "1em" }}>
					<Stack direction="column">
						<Typography sx={{ fontWeight: "bold" }}>Existing Credentials:</Typography>
						<TableContainer component={Paper} sx={{ width: "100%" }}>
							<Table>
								<TableHead>
									<TableRow>
										<TableCell sx={{ textAlign: "left" }}>Email Address</TableCell>
										<TableCell sx={{ textAlign: "left" }}>Username</TableCell>
										<TableCell sx={{ textAlign: "left" }}>Firstname</TableCell>
										<TableCell sx={{ textAlign: "left" }}>Lastname</TableCell>
										<TableCell sx={{ textAlign: "left" }}>Password</TableCell>
										<TableCell sx={{ textAlign: "left" }}>System</TableCell>
										<TableCell sx={{ textAlign: "left" }}>Reference</TableCell>
									</TableRow>
								</TableHead>
								<TableBody>
								{syntheticIds.map((syntheticId) => {
									return (
										<TableRow key={`syntheticid_${syntheticId.id}`}>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.email}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.username}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.firstname}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.lastname}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.password}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.system}
												</Typography>
											</TableCell>
											<TableCell sx={{ textAlign: "left" }}>
												<Typography>
													{syntheticId.reference}
												</Typography>
											</TableCell>
										</TableRow>
									)
								})}
								</TableBody>
							</Table>
						</TableContainer>
						<Typography sx={{ fontWeight: "bold", margin: "2em 0 1em 0" }}>
							Add Credentials:
						</Typography>
					</Stack>
					<form onSubmit={handleSubmitForm} autoComplete="off">
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="system">System</InputLabel>
							<Input inputRef={system} id="system"/>
						</FormControl>
						<FormControl sx={formControlStyle}>
							<InputLabel htmlFor="reference">Reference</InputLabel>
							<Input inputRef={reference} id="reference"/>
						</FormControl>
					</form>
				</Stack>
			</DialogContent>
			<DialogActions>
				<Button onClick={handleCancel}>Cancel</Button>
				<Button onClick={handleSubmit} autoFocus>Submit</Button>
			</DialogActions>
			<SubmitModal
				open={showSubmitModal}
				sentSuccess={sentSuccess}
				onClose={handleSubmitModalClose}
			/>
		</Dialog>
	);

}

export default SyntheticIDModal;